"use strict";
// Copyright © 2022 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestAccessAdapter = void 0;
const demarked_1 = require("@d24/demarked");
const adapter_1 = require("../_abstract/adapter");
const adapter_2 = require("../_helpers/adapter");
const _contracts_1 = require("../_contracts");
const RequestAccess_config_1 = require("./RequestAccess.config");
/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
class RequestAccessAdapter extends adapter_1.AbstractAdapter {
    objectToToken(object, storage) {
        if (!storage) {
            throw new Error('Argument of storage should be present to [image] module');
        }
        const identifier = typeof object.id !== 'undefined' ? object.id : storage.uniqueKey();
        storage.store(identifier, object.content);
        return {
            content: identifier,
            raw: `#FORM[ id: ${identifier} ]`,
            type: demarked_1.TokenType.Form
        };
    }
    tokenToObject(token, storage) {
        if (!storage) {
            throw new Error('Argument of storage should be present to [image] module');
        }
        const content = storage.retrieve(token.content, RequestAccess_config_1.initialContent);
        return {
            ...adapter_2.getModuleBase(),
            content,
            driver: _contracts_1.ModuleDriver.RequestAccess
        };
    }
}
exports.RequestAccessAdapter = RequestAccessAdapter;
//# sourceMappingURL=RequestAccess.adapter.js.map